import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { isAppHistory } from 'acscp/store/history';
import { home } from 'acscp/components/routeHelper';

interface GoBackLinkProps {
    /**
     * Address to navigate to if there is no previous page in history.
     * If not set, the standard goBack() functionality is triggered.
     */
    fallbackAddress?: string;
    className?: string;
}

const GoBackLinkPresentational: React.SFC<GoBackLinkProps & RouteComponentProps<any>> =
    ({history, fallbackAddress, className, children}) => {

    const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (!fallbackAddress || isAppHistory(history) && history.canGoBackWithinApp()) {
            event.preventDefault();
            history.goBack();
        }
    };

    // If fallbackAddress is not set, the default goBack() functionality will be triggered,
    // thus making "to" property on the Link irrelevant.
    // However, "to" is a required property on the Link, so we provide a default address.
    const to = fallbackAddress || home();

    return (
        <Link className={className} to={to} onClick={clickHandler}>
            {children}
        </Link>
    );
};

/**
 * A "Go back" link with optional functionality of providing a fallback address.
 * If set, then it will be used as the link target when the user has never transitioned within the app.
 *
 * IMPORTANT: react-router's Router component should be supplied with a history that implements AppHistory
 * interface for correct functionality.
 */
const GoBackLink = withRouter(GoBackLinkPresentational);
export {GoBackLink};
